<p-toast></p-toast>
<p-confirmDialog header="Atenção" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="rd-info" *ngIf="!podeEditar">Só quem pode editar modelos (.E.) usa a IA dos relatórios.</div>

<div class="ia" #raiz *ngIf="podeEditar" [style.height]="altura">
  <header class="ia-topo">
    <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text p-button-rounded p-button-secondary" aria-label="Voltar para a lista"
      (click)="descartar()"></button>
    <div class="ia-identidade">
      <h1>Criar com IA</h1>
      <p>Descreva o relatório. A IA lê a estrutura da base escolhida, reaproveita uma fonte quando dá ou escreve o SQL de uma nova. Nada é salvo sem você.</p>
    </div>
    <habil-seletor-base></habil-seletor-base>
    <button pButton type="button" class="p-button-text p-button-secondary" label="Descartar" (click)="descartar()"></button>
    <button pButton type="button" class="p-button-outlined" icon="pi pi-database" label="Revisar fonte" *ngIf="fonteNova && podeSql" [disabled]="pensando"
      (click)="revisarFonte()"></button>
    <button pButton type="button" icon="pi pi-check" label="Salvar e abrir modelo" [disabled]="!podeSalvar || pensando" [loading]="salvando" (click)="salvar()"></button>
  </header>

  <div class="ia-corpo">
    <section class="rd-painel ia-conversa" aria-label="Conversa">
      <habil-conversa-ia [mensagens]="mensagens" [ocupado]="pensando" [rotuloCampo]="proposta ? 'Pedir um ajuste' : 'O que o relatório precisa mostrar'"
        [placeholder]="proposta ? 'Ex.: tira os títulos em protesto e mostra o total por vendedor no topo' : 'Ex.: contas a receber vencidas, agrupadas por cliente, com dias de atraso e total por faixa: até 30, 31 a 60, 61 a 90 e mais de 90 dias'"
        [vazio]="service.base ? 'Escreva o relatório como pediria para alguém da equipe. Quanto mais claro o que conta e o que não conta, melhor.' : 'Escolha a base no topo: a IA lê a estrutura do banco dessa base.'"
        (enviar)="enviar($event)"></habil-conversa-ia>
    </section>

    <div class="ia-proposta">
      <div class="ia-vazia" *ngIf="!proposta">
        <i class="pi pi-file"></i>
        <span>A proposta aparece aqui: a fonte SQL, o desenho do relatório e a prévia com os dados da base.</span>
      </div>

      <ng-container *ngIf="proposta">
        <section class="rd-painel">
          <div class="rd-painel-titulo">
            {{ proposta.modelo?.titulo || 'Proposta' }}
            <span class="rd-painel-extra" *ngIf="proposta.modelo?.chave"><code>{{ proposta.modelo.chave }}</code></span>
          </div>
          <dl class="ia-resumo">
            <ng-container *ngFor="let r of resumo">
              <dt>{{ r.rotulo }}</dt>
              <dd>{{ r.valor }}</dd>
            </ng-container>
          </dl>
          <div class="ia-selos">
            <span class="ia-selo ia-selo-ok" *ngIf="!proposta.erros?.length"><i class="pi pi-check"></i>Passou na conferência</span>
            <span class="ia-selo ia-selo-erro" *ngIf="proposta.erros?.length"><i class="pi pi-times"></i>{{ proposta.erros.length }} problema(s) na conferência</span>
            <span class="ia-selo ia-selo-ok" *ngIf="fonteNova && !proposta.erros?.length"><i class="pi pi-check"></i>SQL rodou na base (sem trazer dados)</span>
            <span class="ia-selo ia-selo-aviso" *ngIf="fonteNova && !podeSql"><i class="pi pi-lock"></i>SQL novo precisa de alguém com permissão de SQL</span>
          </div>
        </section>

        <section class="rd-painel" *ngIf="fonteNova">
          <div class="rd-painel-titulo">
            Fonte nova · SQL
            <span class="rd-painel-extra"><code>{{ proposta.fonte.chave }}</code></span>
          </div>
          <habil-editor-codigo [valor]="proposta.fonte.sql" linguagem="sql" altura="280px" [somenteLeitura]="true" nomeArquivo="fonte-ia.sql"></habil-editor-codigo>
        </section>

        <section class="rd-painel">
          <div class="rd-painel-titulo">
            Prévia
            <span class="rd-painel-extra">{{ service.base?.descricao || 'escolha a base no topo' }}</span>
            <button pButton type="button" icon="pi pi-refresh" class="p-button-text p-button-rounded p-button-sm" aria-label="Rodar prévia de novo"
              [loading]="rodandoPrevia" [disabled]="!!proposta.erros?.length" (click)="rodarPrevia()"></button>
          </div>
          <div class="rd-erros ia-erro-previa" *ngIf="erroPrevia">{{ erroPrevia }}</div>
          <div class="ia-previa" [class.ia-previa-velha]="rodandoPrevia">
            <habil-resultado-relatorio *ngIf="resultado" [resultado]="resultado"></habil-resultado-relatorio>
            <div class="ia-vazia-pequena" *ngIf="!resultado && !erroPrevia">
              {{ proposta.erros?.length ? 'Corrija os problemas pela conversa para ver a prévia.' : 'Rodando a prévia…' }}
            </div>
          </div>
        </section>
      </ng-container>
    </div>
  </div>
</div>
